import { createReducer } from '@reduxjs/toolkit';
import type { ICustomerBase } from '../../api/domain';
import { fetchCustomerBasesSuccess, readDefaultCustomerBaseSuccess, updateCustomerBases } from './customer-base-api-actions';

interface ICustomerBaseApiState {
    customerBases: ICustomerBase[];
    defaultCustomerBase?: ICustomerBase;
}
export type { ICustomerBaseApiState };

export const initialState: ICustomerBaseApiState = {
    customerBases: [],
};

export const customerBaseApiReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(fetchCustomerBasesSuccess, (state, { payload: customerBases }) => {
            state.customerBases = customerBases;
        })
        .addCase(readDefaultCustomerBaseSuccess, (state, { payload: customerBases }) => {
            state.defaultCustomerBase = customerBases;
        })
        .addCase(updateCustomerBases, (state, { payload: customerBases }) => {
            state.customerBases = customerBases;
        });
});
